import { FormattedMessage } from 'react-intl';
import { matchPath, useLocation } from 'react-router-dom';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { ExtraMessageWithBlurredBg } from '@sorare/core/src/components/onboarding/ExtraMessageWithBlurredBg';
import { HighlightOverlay } from '@sorare/core/src/components/onboarding/HighlightOverlay';
import { MLB_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';
import { useLifecycle } from '@sorare/core/src/hooks/useLifecycle';

type Props = {
  claimDialogOpen: boolean;
  hasClaimTaskReady?: boolean;
  setClaimDialogOpen: (open: boolean) => void;
};

export const DailyClaimButtonOnboarding = ({
  claimDialogOpen,
  hasClaimTaskReady,
  setClaimDialogOpen,
}: Props) => {
  const location = useLocation();
  const isTabletAndAbove = useIsTabletAndAbove();
  const { lifecycle } = useLifecycle();
  const shouldShowOnboarding =
    lifecycle?.sawMLBLobbyOnboarding && !lifecycle?.sawMLBDailyClaimButton;

  if (
    claimDialogOpen ||
    !hasClaimTaskReady ||
    !shouldShowOnboarding ||
    !matchPath(MLB_HOME, location.pathname)
  ) {
    return null;
  }

  return (
    <HighlightOverlay
      stayOpen
      disableBackdropClose
      highlightNames={['DailyClaimButton']}
      onClose={() => {
        setClaimDialogOpen(true);
      }}
      extras={[
        {
          nextTo: 'DailyClaimButton',
          render: props => (
            <ExtraMessageWithBlurredBg
              align="center"
              anchor="bottom"
              positionProps={props}
              fullWidth={!isTabletAndAbove}
            >
              <LabelL>
                <FormattedMessage
                  id="DailyClaimButtonOnboarding.title.v2"
                  defaultMessage="Claim a daily reward every 24 hours!"
                />
              </LabelL>
            </ExtraMessageWithBlurredBg>
          ),
        },
      ]}
    />
  );
};
